// extracted by mini-css-extract-plugin
module.exports = {"link":"link-button-module--link--1pkuF","center":"link-button-module--center--24UxB"};